import React from 'react';
import styles from './HomePage.module.css';
import { HomeCard } from './HomeCard/HomeCard';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Adsense from '../Ads/Adsense';


export const HomePage = () => {
  return (
    <div className={styles.container}>
      <Helmet>
        <title>Enzo's Toolkit - 복리 계산기, 세나 쿠폰 등록기</title>
        <meta name="description" content="Enzo's Toolkit은 복리 계산기, 세븐나이츠 쿠폰 일괄 등록기 등 유용한 웹 도구를 제공하여 여러분의 시간을 아껴드립니다." />
      </Helmet>
      <header className={styles.header}>
        <h1>Enzo's Toolkit에 오신 것을 환영합니다!</h1>
        <p>필요할 때 찾아 쓰는 공구함, 여러분의 시간을 아껴드립니다.</p>
      </header>

      <Adsense adClient="ca-pub-9359050149154028" adSlot="6979626644" />

      <main className={styles.main}>
        <h2>도구 목록</h2>
        <div className={styles.cardGrid}>
          <Link to="/compound">
            <HomeCard
              title="복리 계산기"
              description="투자의 미래 가치를 시뮬레이션하여 부의 성장을 계획해보세요."
            />
          </Link>
          <Link to="/coupon/seven-knights">
            <HomeCard
              title="세븐나이츠 쿠폰 등록기"
              description="세븐나이츠의 여러 쿠폰을 한 번에 등록하세요."
            />
          </Link>
          <Link to="/lotto">
            <HomeCard
              title="로또 번호 추천기"
              description="과거 당첨 번호를 분석하여 행운의 번호를 추천합니다."
            />
          </Link>
        </div>


      </main>
    </div>
  );
};
